import { render, staticRenderFns } from "./tagSetting.vue?vue&type=template&id=298a536d&scoped=true"
import script from "./tagSetting.vue?vue&type=script&lang=js"
export * from "./tagSetting.vue?vue&type=script&lang=js"
import style0 from "./tagSetting.vue?vue&type=style&index=0&id=298a536d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a536d",
  null
  
)

export default component.exports